import React from "react";

import { IconBottomOutlined } from "~/components/icon";
import { cx } from "~/tools/class-variance";

import type { TimeRange } from "../../../../../app/state/view/timeline/TimeRange";
import { Button } from "../../../buttons/Button";
import { Tooltip } from "../../../tooltip/Tooltip";
import { FormatViewInterval } from "../../../viewtime/FormatViewInterval";
import type { IconButtonSize } from "../../Buttons";

export interface TimeRangeSelectorButtonProps {
	timeRange: TimeRange;
	active: boolean;
	onClick?: React.MouseEventHandler<HTMLElement>;
	tooltip?: string;
	size?: IconButtonSize;
	disabled?: boolean;
}

export const TimeRangeSelectorButton = React.forwardRef<HTMLButtonElement, TimeRangeSelectorButtonProps>(
	({ onClick, timeRange, active, tooltip = "Set the interval", size = "small", disabled = false }, ref) => (
		<Tooltip title={tooltip}>
			<Button
				active={active}
				className={cx(
					"block border-grey-400 bg-white px-3 py-0 text-13 text-grey-800 shadow-none",
					size === "small" && "h-[23px]",
					size === "middle" && "h-8",
				)}
				data-testid="time-range-selector"
				disabled={disabled}
				onClick={onClick}
				ref={ref}
			>
				{timeRange.isSpecific() ? (
					<FormatViewInterval interval={[timeRange.start(), timeRange.end]} />
				) : (
					timeRange.toUserFriendlyString()
				)}
				<IconBottomOutlined className="ml-2 inline-block align-baseline text-[8px]" />
			</Button>
		</Tooltip>
	),
);
